import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {ScheduleDependencies} from '../dependencies';
import type {ScheduleCalendarRange} from '../domain/schedule-calendar';
import {keys} from './keys';

export type GetScheduleCalendarQueryDependencies = Pick<ScheduleDependencies, 'controllers'>;

/** `null` asks the server for the profile-local current week instead of a client-computed range. */
export const getScheduleCalendarQuery = (
  {controllers}: GetScheduleCalendarQueryDependencies,
  range: ScheduleCalendarRange | null,
) =>
  queryOptions({
    queryKey: keys.calendar(range),
    queryFn: () => controllers.scheduleController.getCalendar(range).then(unwrap),
  });
